export default {
  name: "Intro",
  data() {
    return {
      currentComponent: "Resturants"
    };
  }
};
